export const processEditor = `/analyze-formatting`;
export const upload = `/upload`;
export const analyzeDocument = `/process-docx-corrections`;
export const downloadDoc = `/download-corrected-docx/`
